import { getAlarmHistoryAPI, getVentilatorAlarmHistoryAPI,getVentilatorPreUseHistoryAPI } from "../adapter/cms-adapter";

export const getAlarmHistory = (data) => {
    let promise = new Promise(function (resolve, reject) {
        getAlarmHistoryAPI(data)
            .then((res) => {

                if (res && res.data && res.data.data) resolve(res.data.data);
                else reject("some error message getPMAlarmHistory");
            }).catch((err) => {
                reject("Error in PMAlarms");
            })
    })
    return promise;
}


export const getVentilatorAlarmHistory = (data) => {
    let promise = new Promise(function (resolve, reject) {
        getVentilatorAlarmHistoryAPI(data)
        .then((res) => {
            if (res && res.data && res.data.data) resolve(res.data.data);
            else reject("some error message getVentilatorAlarmHistory");
        }).catch((err) => {
            reject("Error in Ventilator Alarm History");
        })
    })
    return promise;
}

export const getVentilatorPreUseHistory = (data) => {
    let promise = new Promise(function (resolve, reject) {
        getVentilatorPreUseHistoryAPI(data)
        .then((res) => {
            if (res && res.data && res.data.data) resolve(res.data.data);
            else reject("some error message getVentilatorPreUseHistory");
        }).catch((err) => {
            reject("Error in getVentilatorPreUseHistory");
        })
    })
    return promise;
}
